import { C as Carousel } from "./carousel-475facd1.js";
const focusVisiblePolyfill = () => {
  const navKeys = [
    "ARROWUP",
    "ARROWDOWN",
    "ARROWLEFT",
    "ARROWRIGHT",
    "TAB",
    "ENTER",
    "SPACE",
    "ESCAPE",
    "HOME",
    "END",
    "PAGEUP",
    "PAGEDOWN"
  ];
  let currentFocusedElement = null;
  let mouseClick = null;
  window.addEventListener("keydown", (event) => {
    if (navKeys.includes(event.code.toUpperCase())) {
      mouseClick = false;
    }
  });
  window.addEventListener("mousedown", (event) => {
    mouseClick = true;
  });
  window.addEventListener(
    "focus",
    () => {
      if (currentFocusedElement)
        currentFocusedElement.classList.remove("focused");
      if (mouseClick)
        return;
      currentFocusedElement = document.activeElement;
      currentFocusedElement.classList.add("focused");
    },
    true
  );
};
const handleFirstTab = (e) => {
  if (e.keyCode === 9) {
    document.body.classList.add("user-is-tabbing");
    window.removeEventListener("keydown", handleFirstTab);
    window.addEventListener("mousedown", handleMouseDownOnce);
  }
};
const handleMouseDownOnce = () => {
  document.body.classList.remove("user-is-tabbing");
  window.removeEventListener("mousedown", handleMouseDownOnce);
  window.addEventListener("keydown", handleFirstTab);
};
const handleMissingHeading = () => {
  const root = document.querySelector("#root");
  if (root && !root.querySelector("h1")) {
    const newH1 = document.createElement("h1");
    newH1.classList.add("sr-only");
    newH1.innerText = document.title;
    root.insertBefore(newH1, root.firstChild);
  }
};
handleMissingHeading();
const listen = (el, event, handler) => {
  if (!el)
    return () => {
    };
  el.addEventListener(event, handler);
  return () => el.removeEventListener(event, handler);
};
const qsa = (selector, root = document) => Array.from(root.querySelectorAll(selector));
const qs = (selector, root = document) => root.querySelector(selector);
const add = (elOrEls, className) => {
  var _a;
  if (!elOrEls)
    return;
  if (typeof elOrEls.forEach === "function") {
    elOrEls.forEach((el) => {
      var _a2;
      return (_a2 = el == null ? void 0 : el.classList) == null ? void 0 : _a2.add(className);
    });
    return;
  }
  (_a = elOrEls == null ? void 0 : elOrEls.classList) == null ? void 0 : _a.add(className);
};
const remove = (elOrEls, className) => {
  var _a;
  if (!elOrEls)
    return;
  if (typeof elOrEls.forEach === "function") {
    elOrEls.forEach((el) => {
      var _a2;
      return (_a2 = el == null ? void 0 : el.classList) == null ? void 0 : _a2.remove(className);
    });
    return;
  }
  (_a = elOrEls == null ? void 0 : elOrEls.classList) == null ? void 0 : _a.remove(className);
};
const contains = (el, className) => {
  var _a;
  return (_a = el == null ? void 0 : el.classList) == null ? void 0 : _a.contains(className);
};
const selectors = {
  navItems: ".featured-collection-slider__navigation-list-item",
  sliderContainer: ".carousel",
  navButtons: ".carousel__navigation-buttons"
};
const classes = {
  selected: "selected",
  visible: "visible"
};
class FeaturedCollectionSlider {
  constructor(container) {
    this.container = container;
    this.events = [];
    this.carousels = [];
    this._handleNavButton = this._handleNavButton.bind(this);
    this._initCarousels();
  }
  _initCarousels() {
    const { productsPerView, mobileProductsPerView } = this.container.dataset;
    this.perView = parseInt(productsPerView || "0", 10) || 2;
    this.mobilePerView = (parseInt(mobileProductsPerView || "0", 10) || 2) * 1.27;
    this.carouselsElements = qsa(selectors.sliderContainer, this.container);
    this.navItems = qsa(selectors.navItems, this.container);
    this.navigationButtons = qsa(selectors.navButtons, this.container);
    this.navItems.forEach((button) => {
      this.events.push(listen(button, "click", this._handleNavButton));
    });
    this.carouselsElements.forEach((containerEl, index) => {
      const navigationWrapper = qs(
        `[data-navigation="${index}"]`,
        this.container
      );
      const nextButton = navigationWrapper ? qs("[data-next]", navigationWrapper) : null;
      const prevButton = navigationWrapper ? qs("[data-prev]", navigationWrapper) : null;
      const scrollbar = qs(`[data-scrollbar="${index}"]`, this.container) || null;
      this.carousels.push(
        Carousel(containerEl, {
          slidesPerView: this.mobilePerView,
          spaceBetween: 20,
          navigation: nextButton && prevButton ? {
            nextEl: nextButton,
            prevEl: prevButton
          } : false,
          scrollbar: scrollbar ? {
            el: scrollbar,
            draggable: true
          } : false,
          breakpoints: {
            768: {
              slidesPerView: this.perView === 5 || this.perView === 4 ? this.perView - 1 : this.perView
            },
            1200: {
              slidesPerView: this.perView
            }
          }
        })
      );
    });
  }
  _handleNavButton(e) {
    e.preventDefault();
    const { navigationItem } = e.currentTarget.dataset;
    if (!contains(e.currentTarget, classes.selected)) {
      this._hideAll();
      this._show(parseInt(navigationItem, 10));
    }
  }
  _hideAll() {
    remove(this.navItems, classes.selected);
    remove(this.navigationButtons, classes.visible);
    remove(this.carouselsElements, classes.visible);
  }
  _show(index) {
    const navigationWrapper = qs(
      `[data-navigation="${index}"]`,
      this.container
    );
    const collection = qs(`[data-collection="${index}"]`, this.container);
    const navigationItem = qs(
      `[data-navigation-item="${index}"]`,
      this.container
    );
    add(navigationWrapper, classes.visible);
    if (navigationItem)
      add(navigationItem, classes.selected);
    add(collection, classes.visible);
  }
  destroy() {
    this.carousels.forEach((swiper) => {
      var _a;
      return (_a = swiper == null ? void 0 : swiper.destroy) == null ? void 0 : _a.call(swiper);
    });
    this.events.forEach((unsubscribe) => unsubscribe());
  }
}
const initFeaturedCollectionSliders = () => {
  const containers = qsa('[data-section-type="featured-collection-slider"]');
  containers.forEach((container) => {
    if (container.__featuredCollectionSliderInstance)
      return;
    container.__featuredCollectionSliderInstance = new FeaturedCollectionSlider(container);
  });
};
initFeaturedCollectionSliders();
try {
  document.querySelector(":focus-visible");
} catch (e) {
  focusVisiblePolyfill();
}
window.addEventListener("keydown", handleFirstTab);
class ValidatedForm extends HTMLFormElement {
  constructor() {
    super();
    this.setupValidation();
  }
  setupValidation() {
    this.addEventListener("submit", (e) => {
      e.preventDefault();
      this.validateForm();
    });
    const inputs = this.querySelectorAll("input, select, textarea");
    inputs.forEach((input) => {
      input.addEventListener("focus", () => {
        input.classList.add("active");
        input.classList.remove("inactive");
      });
      input.addEventListener("blur", () => {
        if (!input.value) {
          input.classList.remove("active");
          input.classList.add("inactive");
        }
      });
      input.addEventListener("input", () => {
        this.clearError(input);
        if (input.value) {
          input.classList.add("active");
          input.classList.remove("inactive");
        } else {
          input.classList.remove("active");
          input.classList.add("inactive");
        }
      });
      input.addEventListener("invalid", (e) => {
        this.addError(input);
      });
    });
  }
  validateForm() {
    const inputs = this.querySelectorAll("input, select, textarea");
    inputs.forEach((input) => this.clearError(input));
    const requiredFields = this.querySelectorAll("[required]");
    requiredFields.forEach((field) => {
      if (!field.value.trim() || !field.checkValidity()) {
        this.addError(field);
      }
    });
  }
  addError(field) {
    field.classList.add("error");
    field.classList.remove("active");
    field.classList.remove("inactive");
  }
  clearError(field) {
    field.classList.remove("error");
  }
}
customElements.define("validated-form", ValidatedForm, { extends: "form" });
document.querySelectorAll('.form-input-wrapper input[type="text"], .form-input-wrapper input[type="email"], .form-input-wrapper input:not([type])').forEach((input) => {
  const wrapper = input.closest(".form-input-wrapper");
  if (!wrapper)
    return;
  const checkOverflow = () => {
    if (input.scrollWidth > input.clientWidth) {
      wrapper.classList.add("is-overflowing");
    } else {
      wrapper.classList.remove("is-overflowing");
    }
  };
  input.addEventListener("input", checkOverflow);
  window.addEventListener("load", checkOverflow);
});
customElements.define("mega-menu", class extends HTMLElement {
  connectedCallback() {
    this._eventRemovers = [];
    this.meganavHoverEls = this.querySelectorAll(".js-meganav-hover");
    this.meganavContentEls = this.querySelectorAll(".js-meganav-content");
    if (!this.meganavHoverEls || !this.meganavContentEls)
      return;
    this.handleDisplayMeganav();
    this.handleKeyboardNav();
  }
  disconnectedCallback() {
    if (this._eventRemovers) {
      this._eventRemovers.forEach((remove2) => remove2());
      this._eventRemovers = [];
    }
  }
  handleDisplayMeganav() {
    this.meganavHoverEls.forEach((meganavHoverEl, index) => {
      const hoverHandle = () => this.activeMegaMenu(index);
      const keyHandle = (e) => {
        if (e.key === "Enter") {
          e.preventDefault();
          this.activeMegaMenu(index);
        }
      };
      meganavHoverEl.addEventListener("mouseover", hoverHandle);
      meganavHoverEl.addEventListener("focus", hoverHandle);
      meganavHoverEl.addEventListener("keydown", keyHandle);
      this._eventRemovers.push(
        () => meganavHoverEl.removeEventListener("mouseover", hoverHandle),
        () => meganavHoverEl.removeEventListener("focus", hoverHandle),
        () => meganavHoverEl.removeEventListener("keydown", keyHandle)
      );
    });
  }
  handleKeyboardNav() {
    const trigger = this.previousElementSibling;
    if (!trigger || trigger.tagName !== "BUTTON" && trigger.tagName !== "A")
      return;
    const isButton = trigger.tagName === "BUTTON";
    const wrapper = this.parentElement;
    if (!this.id) {
      this.id = `mega-menu-${Math.random().toString(36).slice(2, 8)}`;
    }
    trigger.setAttribute("aria-controls", this.id);
    trigger.setAttribute("aria-expanded", "false");
    this.setAttribute("inert", "");
    let mouseIsOver = false;
    const clearInert = () => this.removeAttribute("inert");
    const setInert = () => {
      if (!this.classList.contains("is-open") && !mouseIsOver) {
        this.setAttribute("inert", "");
      }
    };
    const openDropdown = (moveFocus = true) => {
      clearInert();
      this.classList.add("is-open");
      trigger.setAttribute("aria-expanded", "true");
      if (moveFocus) {
        const firstFocusable = this.querySelector("a, button");
        firstFocusable == null ? void 0 : firstFocusable.focus();
      }
    };
    const closeDropdown = () => {
      this.classList.remove("is-open");
      trigger.setAttribute("aria-expanded", "false");
      setInert();
    };
    const triggerKeydown = (e) => {
      if (isButton && (e.key === "Enter" || e.key === " ")) {
        e.preventDefault();
        this.classList.contains("is-open") ? closeDropdown() : openDropdown();
      } else if (e.key === "Escape") {
        closeDropdown();
      }
    };
    const dropdownKeydown = (e) => {
      if (e.key === "Escape") {
        trigger.focus();
        closeDropdown();
      }
    };
    const wrapperFocusout = (e) => {
      if (!wrapper.contains(e.relatedTarget)) {
        closeDropdown();
      }
    };
    const wrapperMouseenter = () => {
      mouseIsOver = true;
      clearInert();
    };
    const wrapperMouseleave = () => {
      mouseIsOver = false;
      setInert();
    };
    const triggerMouseenter = () => {
      this.classList.remove("is-open");
      trigger.setAttribute("aria-expanded", "false");
      setInert();
    };
    trigger.addEventListener("keydown", triggerKeydown);
    this.addEventListener("keydown", dropdownKeydown);
    wrapper.addEventListener("focusout", wrapperFocusout);
    wrapper.addEventListener("mouseenter", wrapperMouseenter);
    wrapper.addEventListener("mouseleave", wrapperMouseleave);
    trigger.addEventListener("mouseenter", triggerMouseenter);
    this._eventRemovers.push(
      () => trigger.removeEventListener("keydown", triggerKeydown),
      () => this.removeEventListener("keydown", dropdownKeydown),
      () => wrapper.removeEventListener("focusout", wrapperFocusout),
      () => wrapper.removeEventListener("mouseenter", wrapperMouseenter),
      () => wrapper.removeEventListener("mouseleave", wrapperMouseleave),
      () => trigger.removeEventListener("mouseenter", triggerMouseenter)
    );
  }
  activeMegaMenu(index) {
    this.meganavHoverEls.forEach((meganavHoverEl, i) => {
      const isActive = i === index;
      meganavHoverEl.classList.toggle("is-active", isActive);
      const meganavContentEl = this.meganavContentEls[i];
      if (!meganavContentEl)
        return;
      meganavContentEl.hidden = !isActive;
      meganavContentEl.classList.toggle("is-active", isActive);
    });
  }
});
document.addEventListener("rebuy.productsChange", (event) => {
  var _a, _b;
  const { products } = event.detail;
  for (const product of products) {
    if (!((_b = (_a = product.metafields) == null ? void 0 : _a.custom) == null ? void 0 : _b.exclude_options))
      continue;
    let excludeOptions;
    try {
      excludeOptions = JSON.parse(product.metafields.custom.exclude_options);
    } catch {
      continue;
    }
    if (!excludeOptions.length)
      continue;
    const exclusionList = [];
    for (const excludeEntry of excludeOptions) {
      const colonIndex = excludeEntry.indexOf(":");
      if (colonIndex === -1)
        continue;
      const optionName = excludeEntry.slice(0, colonIndex).trim().toLowerCase();
      const optionValue = excludeEntry.slice(colonIndex + 1).trim().toLowerCase();
      const optionIndex = product.options.findIndex((option) => option.name.toLowerCase() === optionName);
      if (optionIndex !== -1) {
        exclusionList.push({ key: `option${optionIndex + 1}`, value: optionValue });
      }
    }
    if (!exclusionList.length)
      continue;
    product.variants = product.variants.filter(
      (variant) => !exclusionList.some((exclusion) => {
        var _a2;
        return ((_a2 = variant[exclusion.key]) == null ? void 0 : _a2.toLowerCase()) === exclusion.value;
      })
    );
  }
});
